export * from 'RLX/State/Ui/Sidebar/SidebarCreators';

export const fatalError = (errorMessage) => {
  return {
    payload: { errorMessage },
    type: 'ui/FATAL_ERROR'
  };
};

export const savedTimeUpdated = () => {
  const time = Date.now();
  return {
    payload: { time },
    type: 'content/SAVED_TIME_UPDATED'
  }
};

export const resetBrokenFlag = () => {
  return { type: 'ui/RESET_BROKEN_FLAG' };
};

export const changesMade = () => {
  return { type: 'ui/CHANGES_MADE' };
};

export const changesSaved = () => {
  return { type: 'ui/CHANGES_SAVED' };
};

export const loadingStarted = () => {
  return { type: 'ui/LOADING_STARTED' };
};

export const loadingFinished = () => {
  return { type: 'ui/LOADING_FINISHED' };
};

export const loadedInitialState = () => {
  return { type: 'ui/LOADED_INITIAL_STATE' };
};



// WEBPACK FOOTER //
// ./client/RLX/State/Ui/UiCreators.js